import { Agent } from '@/components/agents-table/mixins/util';
import sortService from '@/views/agents/services/sort_utils';

export const actionValues = {
  // EnableAgent: ['DisabledAsHelper', 'Ready'],
  // SetAgentPriority: ['low', 'normal', 'high'],
  // SetAgentLoggingLevel: ["Minimal", "Basic", "Intermediate", "Extended", "Detailed"],
  // SetAgentAssignPriority: ["LowAssignPriority", "BelowNormalAssignPriority", "NormalAssignPriority", "AboveNormalAssignPriority", "HighAssignPriority"],
  // SetBuildGroup: 'value',
  // SetBuildPriority: ["LowBuildPriority", "BelowNormalBuildPriority", "NormalBuildPriority", "AboveNormalBuildPriority", "HighBuildPriority"],
  EnableAgent: value => value,
  SetAgentPriority: value => value,
  SetAgentLoggingLevel: value => ['Minimal', 'Basic', 'Intermediate', 'Extended', 'Detailed'].indexOf(value),
  SetAgentAssignPriority: value => value,
  SetBuildGroup: value => value,
  SetBuildPriority: value => value,
  ResizeAgentCache: value => value,
};

export function translateAction(action, value) {
  if (actionValues[action]) {
    return actionValues[action](value);
  }
  return 'no-val';
}
export const Mutations = {
  addAgentIntoActionMenu(state, data) {
    if (!data) return;
    state.actionMenu[data.Name] = new Agent(data);
  },
  // agentList expects array of agents
  setAgentLock(state, data) {
    state.agentsLocked = { ...state.agentsLocked, [data.agentName]: data.value };
  },

  tablePagination(state, payload) {
    state.tablePagination = payload;
    sortService.sortAgents(state.agentsList, payload, newAgents => {
      state.agentsList = newAgents;
    });
    state.agentsList = sortService.handleDuplicateAgentsSort(state.agentsList);
  },
};
